// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0e822c44","977":"af6be0f9"}[chunkId] + ".chunk.js";
};